import { useEffect } from 'react'

interface PageMetadataProps {
  description: string
  title: string
}

const upsertDescription = (description: string) => {
  let metaDescription = document.querySelector(
    'meta[name="description"]'
  ) as HTMLMetaElement | null

  if (!metaDescription) {
    metaDescription = document.createElement('meta')
    metaDescription.name = 'description'
    document.head.appendChild(metaDescription)
  }

  metaDescription.content = description
}

const PageMetadata = ({ description, title }: PageMetadataProps) => {
  useEffect(() => {
    document.title = title
    upsertDescription(description)
  }, [description, title])

  return null
}

export default PageMetadata
